import * as React from 'react';

import {AiFeatureCard} from 'shells/ai-homepage/ai-feature-card/ai-feature-card';
import {Card} from 'shells/card/card';
import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {StatCard} from 'shells/metrics/stat-card/stat-card';
import {Body} from 'shells/typography/body';

import {appHistory} from '../../../history';

import {getFeature} from '../features/features-list';
import {getSelectedUsageTab} from '../helpers';

import styles from './usage-section.module.css';

// Should never be a feature flagged feature
const EMPTY_STATE_FEATURE_TYPE = 'EMAIL_CAMPAIGN_BUILDER';

export function NoUsageSection() {
    const hightlightFeature = getFeature(EMPTY_STATE_FEATURE_TYPE);
    const selectedPeriod = getSelectedUsageTab(window.location.search);

    return (
        <>
            <Stack spacing={16} isHorizontal={true} isFullWidth={true}>
                <div className={styles['no-usage-left-section']}>
                    <StatCard displayName='Features used' value='0' type='percent' />
                    <AiFeatureCard
                        key={hightlightFeature.type}
                        title={hightlightFeature.name}
                        description={hightlightFeature.cardDescription}
                        thumbnailIllustration={hightlightFeature.cardIllustration}
                        icon={hightlightFeature.icon}
                        history={appHistory}
                        exploreLink={`/ai/home/${
                            hightlightFeature.pathSegment
                        }?period=${selectedPeriod.toLowerCase()}`}
                    />
                </div>
                <Card
                    hasBorder={true}
                    hasShadow={true}
                    borderRadius={8}
                    fitHeight={true}
                    borderColor={colors.buttonSecondaryDk}
                >
                    <div className={styles['no-usage-right-section']}>
                        <div className={styles['no-usage-right-text']}>
                            <Body size='large' isBold={true} useDoyle={true}>
                                No data to show, yet!
                            </Body>
                            <Body size='small'>
                                This section offers insights on hours saved per feature,
                                leaderboards, and more as you use AI features.
                            </Body>
                        </div>
                        <Illustration src='ai-homepage-no-usage' />
                    </div>
                </Card>
            </Stack>
        </>
    );
}
